class VariantUSPs extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		document.addEventListener('variant:change', (event) => {
			this.updateUSPs(event);
		});
		document.addEventListener('DOMContentLoaded', () => {
			this.section = this.closest('section');
			this.textWithIconsContent = this.section?.querySelector('.text-with-icons');
			if (!this.section || !this.textWithIconsContent) {
				return;
			}
			this.directTextWithIconsItems = Array.from(
				this.textWithIconsContent.querySelectorAll(':scope > .text-with-icons__item'),
			);
			this.variantUSPs = Array.from(this.textWithIconsContent.querySelectorAll('[data-variant-id]'));
			this.carouselNavigation = this.section.querySelector(
				`carousel-navigation[aria-controls="${this.textWithIconsContent.id}"]`,
			);
			this.carouselButtons = this.carouselNavigation
				? Array.from(this.carouselNavigation.querySelectorAll('button'))
				: [];
			this.hideSection();
			this.navigationInit();
		});
	}

	updateUSPs(event) {
		if (!this.textWithIconsContent) {
			return;
		}
		const variant = event.detail.variant;
		this.variantUSPs.forEach((usp) => {
			const uspId = usp.getAttribute('data-variant-id');

			if (parseInt(uspId) === variant.id) {
				usp.classList.remove('hidden');
			} else {
				usp.classList.add('hidden');
			}
		});
		const hiddenIndexes = [];
		const visibleItems = [];
		this.directTextWithIconsItems.forEach((item, index) => {
			if (item.classList.contains('hidden')) {
				hiddenIndexes.push(index);
			} else {
				visibleItems.push(item);
			}
		});
		if (typeof this.textWithIconsContent.filter === 'function') {
			this.textWithIconsContent.filter(hiddenIndexes);
		}
		if (visibleItems.length > 0) {
			const visibleCells = typeof this.textWithIconsContent.cells !== 'undefined' ? this.textWithIconsContent.cells : [];
			const firstVisibleCell = visibleCells[0] || visibleItems[0];

			if (firstVisibleCell) {
				this.directTextWithIconsItems.forEach((item) => {
					item.classList.toggle('is-selected', item === firstVisibleCell);
					item.style.setProperty('opacity', 1);
					item.style.setProperty('transform', 'translateY(0)');
				});
			}

			if (typeof this.textWithIconsContent.select === 'function') {
				this.textWithIconsContent.select(0, { instant: true });
			}
		}

		this.updateNavigationButtons();
		this.hideSection();
	}

	hideSection() {
		this.directHiddenChildren = this.variantUSPs.filter((usp) => usp.matches('.hidden'));
		if (this.directHiddenChildren.length === this.childElementCount && this.directTextWithIconsItems.length === 0) {
			this.section.classList.add('hidden');
		} else {
			this.section.classList.remove('hidden');
		}
	}

	updateNavigationButtons() {
		if (!this.carouselNavigation || this.carouselButtons.length === 0) {
			return;
		}

		let visibleCount = 0;
		this.directTextWithIconsItems.forEach((item, index) => {
			const button = this.carouselButtons[index];
			if (!button) {
				return;
			}
			const isHidden = item.classList.contains('hidden');
			button.classList.toggle('hidden', isHidden);
			if (!isHidden) {
				visibleCount += 1;
			}
		});

		this.carouselNavigation.classList.toggle('hidden', visibleCount <= 1);
		const currentButton = this.carouselButtons.find((button) => button.getAttribute('aria-current') === 'true');
		if (currentButton && currentButton.classList.contains('hidden')) {
			currentButton.setAttribute('aria-current', 'false');
			const firstVisibleButton = this.carouselButtons.find((button) => !button.classList.contains('hidden'));
			if (firstVisibleButton) {
				firstVisibleButton.setAttribute('aria-current', 'true');
			}
		}
	}

	navigationInit() {
		if (!this.carouselNavigation || this.carouselButtons.length === 0) {
			return;
		}

		const visibleItemsCount = this.directTextWithIconsItems.filter(
			(item) => !item.hasAttribute('hidden') && !item.classList.contains('hidden')
		).length;

		const buttonsToShow = Math.min(visibleItemsCount, this.carouselButtons.length);

		this.carouselButtons.forEach((button, index) => {
			if (index < buttonsToShow) {
				button.classList.remove('hidden');
			} else {
				button.classList.add('hidden');
			}
		});
	}
}

if (!window.customElements.get('variant-usps')) {
	window.customElements.define('variant-usps', VariantUSPs);
}
